module.exports = __webpack_public_path__ + "img/5-3-active.a326ec13.png";